import { Category } from '@df/catalog/category/category';
import { Nexus } from '@tomandco/nexus-api-types';

Category.onLoad((category: Category) => {
    if (category.hasV3) {
        const data = category.data as Nexus.Lib.Catalog.Model.Category.Data.V3;
        const products = data.products;
        if (data.pageTemplate && data.pageTemplate === 'giftcards' && products && products.length) {
            return new Promise<void>(resolve => category.resources.product.loadAllIds(products, 3, { safe: true }).finally(resolve));
        }
    }
    return undefined;
});
